<div class="">
    <div class="modal-body p-3">

<div class="row" *ngIf="selectedLink == '' && reporterType == 'PC'">
    <div class="col-md-12">
      <div class="title-lg text-primary">
        <span class="pt-1"> <img src="./assets/images/alticon.png" ></span>&nbsp;Report a Product Complaint
        <span class="mt-1 float-right fs-13" data-dismiss="modal" (click)="cancel()">
          <i class="fas fa-times pointer"></i></span>
      </div>
      <p class="fs-12 pt-2 pb-3">
        Contact Product Monitoring to report any quality complaint or medical device report. Full details on contacting Product Monitoring globally can be found <span class="text-underline text-clr pointer font-weight-bold texthover" (click)="navigateToLink('https://www.keenova.com/company/contact-locations/reporting-adverse-events-and-product-complaints/#product-complaints', true)"> here</span>.
      </p>
    </div>
</div>

<div class="row" *ngIf="selectedLink == '' && reporterType == 'AE'">
    <div class="col-md-12">
      <div class="title-lg text-primary">
        <span class="pt-1"> <img src="./assets/images/alticon.png" ></span>&nbsp;Report an Adverse Event
        <span class="mt-1 float-right fs-13" data-dismiss="modal" (click)="cancel()">
          <i class="fas fa-times pointer"></i></span>
      </div>
      <p class="fs-12 pt-2 pb-3">
        We encourage you to contact Global Pharmacovigilance to report any side effect/adverse drug experience related to a Mallinckrodt product. Full details on contacting Pharmacovigilance can be found <span class="text-underline text-clr pointer font-weight-bold texthover" (click)="navigateToLink('https://www.keenova.com/company/contact-locations/reporting-adverse-events-and-product-complaints/#adverse-events', true)">here</span>.
      </p>
      <p class="fs-12 pt-2 pb-3" *ngIf="isUS_Profile">
        If you are located in the United States: You may also contact the U.S. Food and Drug Administration (FDA) directly to report adverse events or product quality concerns either online at <a href="javascript:void(0)" class="text-underline font-weight-bold" (click)="navigateToLink('https://www.fda.gov/safety/medwatch-fda-safety-information-and-adverse-event-reporting-program', false)"> www.fda.gov/medwatch </a> or by calling (800)-332-1088.
      </p>
      <p class="fs-12 pt-2 pb-3">
        The Global Pharmacovigilance Department (GPV) is responsible for the collection, processing and analysis of adverse events for Mallinckrodt's pharmaceutical products in compliance with regulatory requirements. The goals of the GPV Department are to minimize or prevent harm to patients by identifying new safety concerns and/or hazards associated with Mallinckrodt medicinal products and to implement risk-minimization measures when appropriate. 
      </p>
    </div>
</div>

<div class="row" *ngIf="selectedLink != ''">
    <div class="col-md-12">
      <p class="fs-12 text-center" *ngIf="isMNKLink">
        You are now leaving the Mallinckrodt Medical Information Portal. 
      </p>
      <p class="fs-12 text-center" *ngIf="!isMNKLink">
        Links to sites outside of Mallinckrodt Medical Information are provided as a resource to the viewer. This third-party website is neither owned nor controlled by Mallinckrodt, and Mallinckrodt does not endorse and is not responsible for the content or services on external websites. 
      </p>
      <p class="fs-12 pt-2 pb-3 text-center">
        Do you wish to continue?
      </p>
    </div>
    <div class="col-md-12 text-end">
        <div class="py-3">
          <a href="{{selectedLink}}" class="btn btn-sm btn-block" target="_blank" (click) = "_bsModalRef.hide()"> Yes, I want to leave the Medical Information Portal </a>
          <a href="javascript:void(0);" class="btn btn-sm btn-block" (click) = "cancel()">Cancel</a>
        </div>
    </div>
</div>

    </div>
</div>
